"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRolesEnum = void 0;
var UserRolesEnum;
(function (UserRolesEnum) {
    UserRolesEnum["ADMIN"] = "Admin";
    UserRolesEnum["TECH"] = "Tech";
    UserRolesEnum["FINANCE"] = "Finance";
})(UserRolesEnum = exports.UserRolesEnum || (exports.UserRolesEnum = {}));
